import { takeEvery, all, fork, put } from "redux-saga/effects";
import {
  FETCH_ALL_CUSTOMER_APPOINTMENT,
  CANCEL_CUSTOMER_APPOINTMENT,
} from "../constants/ActionTypes";
import axios from "../services/customer";
import * as actions from "../actions";

function* fetchAllCustomerAppointment() {
  try {
    const user = JSON.parse(localStorage.getItem('user-data'));
    const response = yield axios.get(`/appointments?customer=${user._id}`);

    yield put(actions.fetchAllCustomerAppointmentSuccess({Appointments: response.data}));
  } catch (error) {}
}

function* cancelCustomerAppointment({payload}) {
  try {
    // const response = yield axios.get(`/appointments?customer=${user._id}`);
    const response = yield axios.put(`/appointments/${payload}`, {
      status: 'canceled',
    });

    yield put(actions.cancelCustomerAppointmentSuccess(response.data));
  } catch (error) {}
}

export default function* rootSaga() {
  yield all([
    takeEvery(FETCH_ALL_CUSTOMER_APPOINTMENT, fetchAllCustomerAppointment),
    takeEvery(CANCEL_CUSTOMER_APPOINTMENT, cancelCustomerAppointment),
  ]);
}



// WEBPACK FOOTER //
// ./sagas/CustomerAppointment.js